// extracted by mini-css-extract-plugin
export var standaloneTable = "_eu-0";
export var standaloneTableWithBodyFill = "_eu-1";
export var withExtraHeader = "_eu-2";